import formatFloatForDisplay from './formatFloatForDisplay';
import numericStringToFloat from './numericStringToFloat';

/**
 * A calculated price kept with more decimals (so quantities do not grow its rounding)
 * shown in cents, e.g. "5,313" as "5,31". A text with at most two decimals, e.g. one
 * being typed, is shown as it is.
 */
const showInCents = (text: string): string =>
  /[,.]\d{3,}$/.test(text.trim())
    ? formatFloatForDisplay(numericStringToFloat(text))
    : text;

export default showInCents;
